import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox, Col, Form, Input, Row } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import { setDeliveryModalIsOpen } from 'store/slices/layoutSlice';
import { readSitePreview } from 'helpers/sitePreview';
import Icon from 'components/Icon';
import NalchikFreeDeliveryBar from './NalchikFreeDeliveryBar';

const CheckoutFormAddress = () => {
	const dispatch = useDispatch();
	const [sitePreview] = useState(readSitePreview);
	const { address } = useSelector(state => state.layout.deliveryModalData);

	const handleDeliveryModalOpen = e => {
		e.preventDefault();
		dispatch(setDeliveryModalIsOpen(true));
	};

	return (
		<div className='checkout-address-section'>
			<Form.Item
				label='Адрес доставки'
				style={{ marginBottom: address ? '16px' : '0' }}
			>
				<div className='checkout-address-hint'>
					Если адрес не подставляется, попробуйте ещё раз или перезагрузите страницу.
				</div>
				{address ? (
					<button
						type='button'
						className='checkout-address-button'
						onClick={handleDeliveryModalOpen}
					>
						<span>{address}</span>
						<Icon name='icon-chevron-down' className='checkout-address-edit-icon' />
					</button>
				) : (
					<Button
						type='primary'
						icon={<PlusOutlined />}
						onClick={handleDeliveryModalOpen}
						className='checkout-address-add-button'
					>
						Добавьте адрес
					</Button>
				)}
			</Form.Item>
			{address && (
				<Row gutter={12}>
					<Col xs={12} sm={6}>
						<Form.Item name='room' label='Квартира/Офис'>
							<Input className='checkout-address-detail-input' />
						</Form.Item>
					</Col>
					<Col xs={12} sm={6}>
						<Form.Item
							name='entrance'
							label='Подъезд'
							className='checkout-address-item-offset'
						>
							<Input className='checkout-address-detail-input' />
						</Form.Item>
					</Col>
					<Col xs={12} sm={6}>
						<Form.Item
							name='floor'
							label='Этаж'
							className='checkout-address-item-offset'
						>
							<Input className='checkout-address-detail-input' />
						</Form.Item>
					</Col>
					<Col xs={12} sm={6}>
						<Form.Item
							name='intercom'
							label='Домофон'
							className='checkout-address-item-offset'
						>
							<Input className='checkout-address-detail-input' />
						</Form.Item>
					</Col>
				</Row>
			)}
			{address && <NalchikFreeDeliveryBar />}
			{sitePreview && (
				<Form.Item
					name='express_delivery'
					valuePropName='checked'
					style={{ marginBottom: 16 }}
				>
					<Checkbox className='checkout-express'>
						<span className='checkout-express-body'>
							<span className='checkout-express-title'>Экспресс-доставка</span>
							<span className='checkout-express-note'>
								Быстрее обычного интервала
							</span>
						</span>
					</Checkbox>
				</Form.Item>
			)}
			<Form.Item
				style={{ marginBottom: 0 }}
				name='address_1'
				rules={[
					{ required: true, message: 'Выберите адрес доставки' },
					{
						validator: (_, value) => {
							const v = (value || '').trim();
							if (!v) return Promise.resolve(); // required уже проверит
							if (v.length < 10) {
								return Promise.reject(
									'Укажите полный адрес: улицу и номер дома, не только город'
								);
							}
							if (!/\d/.test(v)) {
								return Promise.reject(
									'В адресе должен быть номер дома'
								);
							}
							return Promise.resolve();
						},
					},
				]}
			>
				<Input type='hidden' />
			</Form.Item>
			<Form.Item style={{ display: 'none' }} name='shipping_total'>
				<Input />
			</Form.Item>
		</div>
	);
};

export default CheckoutFormAddress;
